import { render, staticRenderFns } from "./gameSingle.vue?vue&type=template&id=05d7b9bb&scoped=true"
import script from "./gameSingle.vue?vue&type=script&lang=js"
export * from "./gameSingle.vue?vue&type=script&lang=js"
import style0 from "./gameSingle.vue?vue&type=style&index=0&id=05d7b9bb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d7b9bb",
  null
  
)

export default component.exports